import { render, staticRenderFns } from "./GradientLegend.vue?vue&type=template&id=797a7bf2&scoped=true"
import script from "./GradientLegend.vue?vue&type=script&lang=ts"
export * from "./GradientLegend.vue?vue&type=script&lang=ts"
import style0 from "./GradientLegend.vue?vue&type=style&index=0&id=797a7bf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797a7bf2",
  null
  
)

export default component.exports